/**
 * @generated SignedSource<<e8e2d5695d432e2b094c2e15d6997bca>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AcceptTerms_viewer$data = {
  readonly id: string;
  readonly actualPersonId: string | null;
  readonly hasAcceptedTerms: boolean | null;
  readonly " $fragmentType": "AcceptTerms_viewer";
};
export type AcceptTerms_viewer$key = {
  readonly " $data"?: AcceptTerms_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"AcceptTerms_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AcceptTerms_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "actualPersonId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasAcceptedTerms",
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "53f4c055e162301a976503c0edb69ee9";

export default node;
